var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',[_vm._v("©")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_c('b-link',{attrs:{"href":"https://quarticon.com","target":"_blank"}},[_vm._v("QuarticOn")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }